
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CheckboxIcon from './images/checkbox.vue.svg';
import BravadoCheckboxV3 from '~/components/common/BravadoCheckboxV3/BravadoCheckboxV3.vue';

export default Vue.extend({
  name: 'JobsSelectOption',
  components: {
    CheckboxIcon,
    BravadoCheckboxV3,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
    } as PropOptions<boolean>,
    multi: {
      type: Boolean,
    } as PropOptions<boolean>,
  },
});
